<div
  class="meal-report-mgmt flex flex-col min-h-[calc(100vh-100px)] w-full bg-[#F7FAFC] font-['Archivo',sans-serif] px-[24px] md:px-[32px] lg:px-[40px] pt-[24px] pb-[32px]">
  <div *ngIf="isInitialLoading" class="flex flex-col items-center justify-center w-full py-[80px] gap-4">
    <div class="loader-spinner w-12 h-12 border-4 border-[#f26f24ff] border-t-transparent rounded-full animate-spin"></div>
    <span class="text-[#111215] text-[18px]">Loading...</span>
  </div>

  <ng-container *ngIf="!isInitialLoading">
    <div
      class="meal-report-mgmt__panel w-full bg-white rounded-[12px] border border-[#EAECF0] shadow-[0_1px_3px_rgba(16,24,40,0.08),0_1px_2px_rgba(16,24,40,0.06)] p-[24px] flex flex-col gap-[20px]">
      <div class="flex flex-row flex-wrap items-center justify-between gap-[16px]">
        <div class="flex flex-row flex-wrap items-center gap-[16px]">
          <button
            type="button"
            class="inline-flex items-center justify-center gap-[8px] box-border h-[44px] px-[16px] rounded-[16px] border border-[#D0D5DD] bg-white text-[#101828] text-[16px] font-semibold leading-[20px] cursor-pointer hover:bg-[#F9FAFB]"
            (click)="goBack()"
            aria-label="Back">
            <svg
              class="w-5 h-5 shrink-0"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true">
              <path
                d="M20 12H4M4 12L10 18M4 12L10 6"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <span>Back</span>
          </button>
          <h1 class="text-[#111215] font-bold text-[24px] leading-[32px] tracking-[-0.01em] m-0">
            {{ reportTitle }}
          </h1>

          <div class="meal-report-mgmt__mode-toggle" role="group" aria-label="Meal report mode">
            <button
              type="button"
              class="meal-report-mgmt__mode-btn"
              [class.meal-report-mgmt__mode-btn--active]="reportMode === 'ordered'"
              (click)="setReportMode('ordered')">
              Ordered
            </button>
            <button
              type="button"
              class="meal-report-mgmt__mode-btn"
              [class.meal-report-mgmt__mode-btn--active]="reportMode === 'delivered'"
              (click)="setReportMode('delivered')">
              Delivered
            </button>
          </div>
        </div>

        <div class="flex flex-row flex-wrap items-center gap-[10px] justify-end">
          <!-- Figma: This Week with prev / next arrows -->
          <div class="meal-report-mgmt__week-nav" role="group" aria-label="Week range">
            <button
              type="button"
              class="meal-report-mgmt__week-arrow"
              (click)="shiftWeek(-1)"
              aria-label="Previous week">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                  d="M15 18l-6-6 6-6"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </button>
            <button
              type="button"
              class="meal-report-mgmt__week-label"
              (click)="resetToThisWeek()"
              [attr.aria-label]="weekLabel === 'This Week' ? 'This Week' : 'Jump to this week'">
              {{ weekLabel }}
            </button>
            <button
              type="button"
              class="meal-report-mgmt__week-arrow"
              (click)="shiftWeek(1)"
              aria-label="Next week">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                  d="M9 18l6-6-6-6"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </button>
          </div>

          <label class="sr-only" for="meal-report-center">Center</label>
          <select
            id="meal-report-center"
            class="meal-report-mgmt__select meal-report-mgmt__toolbar-control h-[40px] min-w-[160px] rounded-[8px] border border-[#D0D5DD] bg-white px-[12px] pr-[36px] outline-none focus:border-[#F26F24] cursor-pointer"
            [(ngModel)]="filterCenterId"
            (ngModelChange)="onFiltersChanged()">
            <option value="">All Center</option>
            <option *ngFor="let center of centers" [value]="center.id">
              {{ center.locationName }}
            </option>
          </select>

          <button
            type="button"
            class="meal-report-mgmt__toolbar-control inline-flex items-center gap-[8px] h-[40px] px-[14px] rounded-[8px] border border-[#D0D5DD] bg-white cursor-pointer hover:bg-[#F9FAFB] disabled:opacity-50 disabled:cursor-not-allowed"
            (click)="onDownload()"
            [disabled]="!rows.length">
            <img src="assets/icons/download.svg" alt="" class="w-[16px] h-[16px]" />
            Download
          </button>
        </div>
      </div>

      <div *ngIf="errorMessage" class="text-red-600 text-[14px]">
        {{ errorMessage }}
      </div>

      <div *ngIf="isRefreshing" class="text-[#667085] text-[13px]">Updating…</div>

      <div class="meal-report-mgmt__table w-full overflow-x-auto">
        <table *ngIf="!errorMessage" class="w-full border-collapse min-w-full">
          <thead>
            <tr>
              <th scope="col" class="meal-report-mgmt__sticky-col text-left">Center</th>
              <th
                *ngFor="let label of dateLabels"
                scope="col"
                class="text-center whitespace-nowrap">
                {{ label }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="!rows.length">
              <td
                class="text-center text-[#667085] text-[18px] font-medium py-[40px]"
                [attr.colspan]="dateLabels.length + 1 || 1">
                No meal orders found for this period.
              </td>
            </tr>
            <tr *ngFor="let row of rows; trackBy: trackByCenter">
              <td class="meal-report-mgmt__sticky-col text-left whitespace-nowrap">
                {{ row.locationName }}
              </td>
              <td
                *ngFor="let dateKey of dateKeys"
                class="text-center whitespace-nowrap tabular-nums">
                {{ row.values[dateKey] }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>
</div>
